


























































import Vue, { PropType } from 'vue';

// Types and services
import { CandidateJobBuilder, JobMembership } from '~/utils/candidate';
import { jobMembershipValidator } from '~/utils/validators';

// Components
import InfoBox from '../components/InfoBox.vue';
import MembershipListItem from '../components/MembershipListItem.vue';
import MembershipListItemForm from '../components/MembershipListItemForm.vue';

export default Vue.extend({
    name: 'MembershipForm',
    components: { InfoBox, MembershipListItem, MembershipListItemForm },
    props: {
        builder: {
            type: Object as PropType<CandidateJobBuilder>,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            memberships: this.builder.getMemberships(),
            currentOpenMembership: undefined as string | undefined,
        };
    },
    mounted() {
        this.$watch('memberships', this.builder.watchMemberships());
    },
    computed: {
        isValid(): boolean {
            return (
                this.currentOpenMembership === undefined &&
                this.memberships.every(ms => jobMembershipValidator(ms))
            );
        },
    },
    methods: {
        addMemberships() {
            const ms: JobMembership = {
                id: CandidateJobBuilder.generateId(),
                title: '',
                organizationName: '',
                start: new Date(new Date().toISOString().slice(0, 7) + '-01'),
                end: null,
                description: null,
                isActive: false,
            };
            this.memberships.push(ms);
            this.$nextTick(() => {
                this.openMembership(ms);
            });
        },
        removeMembership(membership: JobMembership) {
            this.closeMembership();

            this.$nextTick(() => {
                const memberships = [...this.memberships];
                const idx = memberships.findIndex(we => we.id === membership.id);
                if (idx === -1) {
                    console.warn('Membership not found', membership);
                    return;
                }
                memberships.splice(idx, 1);
                this.memberships = memberships;
            });
        },
        updateMembership(membership: JobMembership) {
            this.closeMembership();
            const memberships = [...this.memberships];
            const idx = memberships.findIndex(we => we.id === membership.id);
            if (idx === -1) {
                console.warn('Membership not found', membership);
                return;
            }
            memberships[idx] = { ...membership };
            this.memberships = memberships;
        },
        openMembership(membership: JobMembership) {
            this.currentOpenMembership = membership.id;
        },
        closeMembership() {
            this.currentOpenMembership = undefined;
        },
    },
});
